import { LayerInfoOverview } from "../types/LayerAdmin/LayerInfoOverview";
import { LayerInfo } from "../types/LayerAdmin/LayerInfo";
import { LogLevel } from "../constant/LogLevel";
import { ImportLogEntry } from "../types/LayerAdmin/ImportLogEntry";
import { DateTime } from "luxon";
import { AxiosInstance } from "axios";

export default class LayerAdminService {
  protected _endpoint = "LayerAdmin";
  protected _client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this._client = client;
  }

  public async getOverview(): Promise<LayerInfoOverview[]> {
    return this._client.get<any>(`${this._endpoint}`).then((response) => {
      return response.data;
    });
  }

  public async getLayerInfo(layerName: string): Promise<LayerInfo> {
    return this._client
      .get<any>(`${this._endpoint}/${layerName}`)
      .then((response) => {
        return response.data;
      });
  }

  public async GetImports(layerName: string, page: number): Promise<any> {
    return this._client
      .get<any>(`${this._endpoint}/${layerName}/imports?page=${page}`)
      .then((response) => {
        return response.data;
      });
  }

  public async GetLog(
    layerName: string,
    importId: string,
    from: DateTime,
    to: DateTime,
    logLevel?: LogLevel
  ): Promise<any> {
    return this._client
      .get<any>(`${this._endpoint}/${layerName}/${importId}/logs`, {
        params: {
          from: from.toUTC().toISO({ includeOffset: false }),
          to: to.toUTC().toISO({ includeOffset: false }),
          logLevel,
        },
      })
      .then((response) => {
        const logs = response.data as ImportLogEntry[];
        const logEntries = logs.map((log) => ({
          ...log,
          date: DateTime.fromISO(log.date.toString()),
        }));

        return logEntries.reverse();
      });
  }
}
